import { format, formatDistanceStrict } from 'date-fns'

export const DEFAULT_DATE_FORMAT_MASK = 'd-MMM-yyyy'
export const DATE_FORMAT_MASK_WITH_TIME = 'd-MMM-yyyy HH:mm'
export const DATE_FORMAT_MASK_WITH_TIMEZONE = 'd-MMM-yyyy HH:mm (OOO)'

export function timeSince(date: Date): string {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000)

  let interval = seconds / 31536000

  if (interval > 1) {
    return Math.floor(interval) + ' years'
  }
  interval = seconds / 2592000
  if (interval > 1) {
    return Math.floor(interval) + ' months'
  }
  interval = seconds / 86400
  if (interval > 1) {
    return Math.floor(interval) + ' days'
  }
  interval = seconds / 3600
  if (interval > 1) {
    return Math.floor(interval) + ' hours'
  }
  interval = seconds / 60
  if (interval > 1) {
    return Math.floor(interval) + ' minutes'
  }

  return Math.floor(seconds) + ' seconds'
}

export function formatDate(date: Date | string, formatMask: string = DEFAULT_DATE_FORMAT_MASK): string {
  const d = date instanceof Date ? date : new Date(date)
  return format(d, formatMask)
}

export function timeAgo(date: Date | string): string {
  const d = date instanceof Date ? date : new Date(date)
  return formatDistanceStrict(d, new Date(), { addSuffix: true })
}

export function formatDuration(minutes: number): string {
  if (minutes < 1) {
    return '0h 0m'
  }

  const d = Math.floor(minutes / (24 * 60))
  const h = Math.floor((minutes % (24 * 60)) / 60)
  const m = Math.floor(minutes % 60)

  const parts: string[] = []
  if (d > 0) {
    parts.push(`${d}d`)
  }
  parts.push(`${h}h`)
  parts.push(`${m}m`)

  return parts.join(' ')
}
